import {Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {EntityServiceClient as EquationEntityServiceClient, MatrixDto, MatrixFilterDto} from '@sharedrest/equation.restservice';
import {Observable} from 'rxjs';
import {UserService} from '@sharedcommon/services/user.service';

@Injectable()
export class RawMaterialMatricesResolver implements Resolve<MatrixDto[]> {

  constructor(private readonly userService: UserService, private readonly equationEntityService: EquationEntityServiceClient) {
  }

  resolve(): Observable<MatrixDto[]> {
    const filter = new MatrixFilterDto();
    return this.equationEntityService.matricesFetch(this.userService.getEntity(), filter);
  }
}
